import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button"; // Import the reusable Button component

interface OTPVerificationProps {
  onBackToRegister: () => void; // Prop to handle the "Back to Register" functionality
}

const OTPVerification: React.FC = () => {
  const navigate = useNavigate();
  const onBackToRegister = () => {
    navigate("/signup");
  };
  const [otp, setOtp] = useState<string[]>(["", "", "", ""]); // State to store OTP digits
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null); // State to track focused input
  const [showTroubleshooting, setShowTroubleshooting] = useState<boolean>(false);

  // Handler for input change
  const handleInputChange = (index: number, value: string) => {
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto focus on the next input if a digit is entered
      if (value && index < otp.length - 1) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  // Handler for pasting OTP
  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedData = event.clipboardData.getData("text");
    if (/^\d{4}$/.test(pastedData)) {
      const newOtp = pastedData.split("");
      setOtp(newOtp);

      // Auto focus on the last input field
      const lastInput = document.getElementById(`otp-${otp.length - 1}`);
      lastInput?.focus();
    }
  };

  // Handler for key down (backspace navigation)
  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    // If backspace is pressed and the current input is empty, focus on the previous input
    if (event.key === "Backspace" && otp[index] === "" && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
      setFocusedIndex(index - 1); // Update focused index to the previous input
    }
  };

  // Handler for form submission
  const handleVerifyOtp = () => {
    navigate("/createAccount");
    // Add your OTP verification logic here
  };


  const handleResend = () => {
    setShowTroubleshooting(true); // Show troubleshooting tips when resend is clicked
  };


  return (
    <div className="lg:col-span-3 col-span-12 lg:col-start-9">
      <img className="w-40" src="/images/logo.svg" alt="Logo" />
      <p className="mt-10 text-2xl font-semibold text-grease-100">
        Sign up to continue
      </p>
      <p className="mt-4 text-grease-50 text-sm">
        We sent a code to joanmir@gmail.com
      </p>
      <div className="flex gap-4 items-center mt-6">
        {otp.map((digit, index) => (
          <div
            key={index}
            className={`bg-lightblue-100 p-4 rounded-lg border ${focusedIndex === index
                ? "border-royalblue-100 text-royalblue-100" // Highlight only the focused input
                : "border-lightblue-200 text-grease-100" // No highlight for non-focused inputs
              } flex-1 text-center font-medium`}
            onClick={() => {
              const input = document.getElementById(
                `otp-${index}`
              ) as HTMLInputElement;
              input?.focus();
              setFocusedIndex(index); // Set the focused input index
            }} // Focus the input on div click
          >
            <input
              id={`otp-${index}`}
              type="text"
              value={digit}
              onChange={(e) => handleInputChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)} // Handle backspace keydown
              onPaste={handlePaste} // Handle paste event
              maxLength={1}
              className="w-full h-full text-center bg-transparent outline-none"
              onFocus={() => setFocusedIndex(index)} // Update focused index on input focus
            />
          </div>
        ))}
      </div>

      {/* Reusable Button */}
      <Button
        onClick={handleVerifyOtp}
        className="w-full p-4 rounded-lg text-white text-center bg-royalblue-100 text-sm mt-6"
      >
        Verify OTP
      </Button>

      {/* Back to Register & Resend Code */}
      <div className="flex items-center justify-between mt-7">
        <div className="flex items-center gap-2 cursor-pointer" onClick={onBackToRegister}>
          <i className="st-arrow-left text-lightgray-200 text-xs"></i>
          <p className="text-xs text-lightgray-200 font-medium cursor-pointer">
            Back to Register
          </p>
        </div>
        <div className="flex items-center justify-center text-xs gap-2">
          <p className="text-grease-200">Don’t receive code?</p>
          <a className="text-royalblue-100 cursor-pointer" onClick={handleResend}>
            Re-send
          </a>
        </div>
      </div>

      
      {/* Troubleshooting tips section */}
      <div
        className={`mt-8 ${showTroubleshooting ? "visibility-visible" : "visibility-hidden"}`}
        style={{ visibility: showTroubleshooting ? "visible" : "hidden" }}
      >
        <p className="font-semibold text-sm mt-8">Troubleshooting tips:</p>
        <div className="flex gap-2 mt-3 items-center">
          <div className="flex items-center justify-center w-4 h-4 text-xs font-medium rounded-full border border-royalblue-100 text-royalblue-100">
            1
          </div>
          <p className="text-lightgray-200 font-normal text-xs">Confirm you entered the correct email address.</p>
        </div>
        <div className="flex gap-2 mt-3 items-center">
          <div className="flex items-center justify-center w-4 h-4 text-xs font-medium rounded-full border border-royalblue-100 text-royalblue-100">
            2
          </div>
          <p className="text-lightgray-200 font-normal text-xs">Check your spam folder.</p>
        </div>
      </div>
    
    </div>
  );
};

export default OTPVerification;